import { classifierColumns, classifierSchema } from '@juvare/platform-sdk-react/backend/features/classifiers/shared';
import { defineColumns } from '@juvare/platform-shared/features/storage';
export const locationTypeEntityName = 'locationType';
export const locationTypeSchema = classifierSchema.extend({});
export const locationTypeColumns = defineColumns(Object.assign(Object.assign({}, classifierColumns), { search: {
        type: 'full-text-search-required',
        language: 'english',
    } }));
